import { useLocation } from 'react-router-dom';
import {
  hasRegionOverrideInSearch,
  readPreviewRegionFromSearch,
} from '@/lib/lyrraone-public-region';
import { usePublicRegionStore } from '@/stores/public-region.store';
import { useLyrraOneRegional } from '@/hooks/useLyrraOneRegional';

/**
 * Badge visible quand la région est forcée via l’URL (`region` ou `preview_region`).
 */
export function LyrraOneRegionUrlBadge() {
  const location = useLocation();
  const region = usePublicRegionStore((s) => s.region);
  const { tx } = useLyrraOneRegional('lyrraoneFooter');

  if (!hasRegionOverrideInSearch(location.search)) return null;

  const isPreview = readPreviewRegionFromSearch(location.search) !== null;
  const label = tx(`region.${region}`);

  return (
    <div
      className="lo-region-url-badge"
      role="status"
      aria-live="polite"
      title="Contenu régional forcé par l’URL — retirez ?region ou ?preview_region pour la version par défaut"
    >
      <span className="lo-region-url-badge-kicker">{isPreview ? 'Aperçu' : 'Région URL'}</span>
      <span className="lo-region-url-badge-value">{label}</span>
    </div>
  );
}

export function getRegionTestUrls(pathname: string): { ma: string; fr: string } {
  const [path, query] = pathname.split('?');
  const base = path || '/';
  const params = new URLSearchParams(query ?? '');
  params.delete('region');
  params.delete('preview_region');
  const rest = params.toString();
  const prefix = rest ? `${base}?${rest}&` : `${base}?`;
  return {
    ma: `${prefix}preview_region=ma`,
    fr: `${prefix}preview_region=fr`,
  };
}
